var render = function render() {
  var _vm$selectPartyInfo3;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "partyInfo"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('el-button', {
    staticClass: "green",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.createParty
    }
  }, [_vm._v(_vm._s(_vm.$t('start.startParty')))]), _c('el-button', {
    staticClass: "joinParty green noBg",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function ($event) {
        _vm.joinPartyInfo.show = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('start.joinParty')))])], 1), _c('div', {
    staticClass: "listHead"
  }, [_vm.showSearch ? _c('el-input', {
    staticClass: "searchInput grayBg",
    attrs: {
      "clearable": true,
      "placeholder": _vm.$t('partyInfo.searchPlaceHolder')
    },
    on: {
      "clear": function ($event) {
        _vm.showSearch = false;
      }
    },
    model: {
      value: _vm.searchInfo,
      callback: function ($$v) {
        _vm.searchInfo = $$v;
      },
      expression: "searchInfo"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-search",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })]) : _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('common.partyList')))]), _c('span', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "iconfont icon-search pointer",
    on: {
      "click": function ($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonPartyHost.leftPane.sorting'),
      "placement": "top"
    }
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "click",
      "popper-class": "sortPopper"
    },
    model: {
      value: _vm.showSortPop,
      callback: function ($$v) {
        _vm.showSortPop = $$v;
      },
      expression: "showSortPop"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-paixu filter pointer",
    class: {
      greenColor: _vm.showSortPop
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _vm._l(_vm.sortList, function (item) {
    return _c('div', {
      key: item.label,
      staticClass: "sortLi",
      class: {
        active: _vm.sortValue.label == item.label
      },
      on: {
        "click": function ($event) {
          return _vm.sortPartyList(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t(`commonPartyHost.leftPane.${item.label}`)))])]);
  })], 2)], 1)], 1)], 1)]), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.scroll,
      expression: "scroll"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: _vm.partyListLoading,
      expression: "partyListLoading"
    }],
    staticClass: "partyList scrollbar grayColor"
  }, _vm._l(_vm.partyList, function (item, index) {
    var _vm$selectPartyInfo, _vm$selectPartyInfo2;
    return _c('div', {
      key: item.id,
      staticClass: "listLi",
      class: {
        active: ((_vm$selectPartyInfo = _vm.selectPartyInfo) === null || _vm$selectPartyInfo === void 0 ? void 0 : _vm$selectPartyInfo.id) && ((_vm$selectPartyInfo2 = _vm.selectPartyInfo) === null || _vm$selectPartyInfo2 === void 0 ? void 0 : _vm$selectPartyInfo2.code) == item.code
      },
      on: {
        "click": function ($event) {
          return _vm.savePartyInfo(item);
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.coHost === 1,
        expression: "item.coHost === 1"
      }]
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('commonFunction.Owner'),
        "placement": "right"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-role"
    })])], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.coHost === 2,
        expression: "item.coHost===2"
      }]
    }, [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('commonFunction.CoHost'),
        "placement": "right"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-a-role1"
    })])], 1), _c('div', {
      staticClass: "listL",
      class: {
        grayColor: item.partyBasicStatus && !item.partyBasicStatus.enable
      }
    }, [!item.edit ? _c('div', [_c('p', {
      staticClass: "partyName",
      attrs: {
        "title": _vm.showTitle(item)
      }
    }, [_vm._v(_vm._s(_vm.showTitle(item)))]), _c('p', {
      staticClass: "partyID",
      attrs: {
        "title": _vm.joinLink + '?join_id=' + item.code + `${_vm.env ? '&env=' + _vm.env : ''}`
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(_vm.$t('partyInfo.partyID')) + ":")]), _vm._v(_vm._s(_vm.returnPartyID(item.code)) + " ")])]) : _c('div', {
      staticClass: "edit left"
    }, [_c('el-input', {
      ref: `input${index}`,
      refInFor: true,
      staticClass: "renameInput",
      class: {
        red: item.redTip
      },
      attrs: {
        "maxlength": 32
      },
      on: {
        "blur": function ($event) {
          return _vm.rename(index, 'blur');
        }
      },
      nativeOn: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return _vm.saveName(index);
        }
      },
      model: {
        value: item.editName,
        callback: function ($$v) {
          _vm.$set(item, "editName", $$v);
        },
        expression: "item.editName"
      }
    }), item.redTip ? _c('p', [_vm._v(_vm._s(item.redMessage))]) : _vm._e()], 1)]), _c('div', {
      staticClass: "listR"
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "200",
        "trigger": "click",
        "popper-class": "partySetting"
      },
      model: {
        value: item.visible,
        callback: function ($$v) {
          _vm.$set(item, "visible", $$v);
        },
        expression: "item.visible"
      }
    }, [_c('i', {
      staticClass: "el-icon-more pointer",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('div', {
      staticClass: "popupBox"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentModule != 'interview',
        expression: "currentModule != 'interview'"
      }],
      staticClass: "pointer popupDiv",
      on: {
        "click": function ($event) {
          return _vm.showSettingPopup(item, index);
        }
      }
    }, [_c('i', {
      staticClass: "icon-shezhi3 grayColor iconfont"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.partySetting')))])]), _c('div', {
      staticClass: "pointer popupDiv",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.rename(index);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit grayColor"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.rename')))])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentModule != 'interview',
        expression: "currentModule != 'interview'"
      }],
      staticClass: "copyLink popupDiv pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.hidePopup(item, index, 'copyLink');
        }
      }
    }, [_c('i', {
      staticClass: "icon-link grayColor iconfont"
    }), _c('span', {
      staticClass: "joinBtn",
      attrs: {
        "icon": "el-icon-link"
      }
    }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.copyLink')))])]), (_vm.isHost || _vm.State.participantRole === 1 || _vm.State.participantRole === 2) && _vm.currentModule != 'interview' ? _c('div', {
      staticClass: "invitation popupDiv pointer",
      on: {
        "click": function ($event) {
          return _vm.showInvited(item, index);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-invitationRules grayColor"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.invitation')))])]) : _vm._e(), item.coHost != 2 && _vm.channelMode[_vm.currentModule] == 0 ? _c('div', {
      staticClass: "pointer popupDiv",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.showAddCoHost(item, index);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-touxiang"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.AddCoHost')))])]) : _vm._e(), item.coHost == 2 && _vm.currentModule === 'party' ? _c('div', {
      staticClass: "pointer popupDiv",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.quitCoHost(item, index);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-touxiang"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.deleteCoHost')))])]) : _vm._e(), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.currentModule != 'interview',
        expression: "currentModule != 'interview'"
      }],
      staticClass: "pointer popupDiv disable",
      on: {
        "click": function ($event) {
          return _vm.showDisablePop(item);
        }
      }
    }, [_c('div', [_c('i', {
      staticClass: "iconfont icon-lock1"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('partyInfo.partyState')))])]), item.loading ? _c('span', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: item.loading,
        expression: "item.loading"
      }],
      staticClass: "disableLoading"
    }) : _c('span', {
      class: _vm.returnDisClass
    }, [_vm._v(_vm._s(_vm.partyStatus.enable ? _vm.$t('partyInfo.enable') : _vm.$t('partyInfo.disable')))])]), item.coHost != 2 ? _c('div', {
      staticClass: "pointer popupDiv",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteParty(item, index);
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete grayColor"
    }), _c('span', [_vm._v(_vm._s(_vm.$t('invite.remove')))])]) : _vm._e()])]), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.partyBasicStatus && item.partyBasicStatus.enable,
        expression: "item.partyBasicStatus && item.partyBasicStatus.enable"
      }],
      staticClass: "greenColor pointer joinBtn",
      attrs: {
        "href": _vm.openPreviewPage(item),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('start.join')))])], 1)]);
  }), 0)]), !_vm.isSelectMode ? _c('div', {
    staticClass: "partyImg"
  }, [_c('rorartionChart', {
    attrs: {
      "isDark": _vm.isDark
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSelectMode,
      expression: "isSelectMode"
    }],
    staticClass: "contentRight"
  }, [_c('div', {
    staticClass: "headContent"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v(_vm._s((_vm$selectPartyInfo3 = _vm.selectPartyInfo) !== null && _vm$selectPartyInfo3 !== void 0 && _vm$selectPartyInfo3.id ? _vm.showTitle(_vm.selectPartyInfo) : '')), JSON.stringify(_vm.partyStatus) != '{}' && !_vm.partyStatus.enable ? _c('i', {
    staticClass: "redColor iconfont icon-lock1"
  }) : _vm._e()]), _c('div', {
    staticClass: "rightTop"
  }, [_c('div', {
    staticClass: "topLeft"
  }, [_vm._l(_vm.partyInfoList, function (item, index) {
    return _c('div', {
      key: item.label,
      staticClass: "leftLi"
    }, [_c('div', {
      staticClass: "titleIcon"
    }, [_c('i', {
      staticClass: "iconfont grayColor",
      class: item.icon,
      style: {
        'font-size': item.label == 'partyID' ? '17px' : '16px'
      }
    }), _c('span', {
      staticClass: "grayColor"
    }, [_vm._v(_vm._s(_vm.$t(`partyInfo.${item.label}`)))]), item.label === 'cohost' ? _c('el-tooltip', {
      staticClass: "cohostLimit",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('partyInfo.cohostLimit'),
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-help2"
    })]) : _vm._e()], 1), _c('span', {
      staticClass: "text w_90"
    }, [item.label === 'cohost' ? [_c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "disabled": !_vm.isTruncated[index],
        "content": _vm.returnContent(_vm.selectPartyInfo, item.label),
        "placement": "top",
        "popper-class": "cohost-tooltip"
      }
    }, [_c('span', {
      ref: 'truncatedText_' + index,
      refInFor: true,
      staticClass: "cohost-truncate",
      on: {
        "mouseenter": function ($event) {
          return _vm.checkTruncated(index);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.returnContent(_vm.selectPartyInfo, item.label)) + " ")])])] : [_vm._v(" " + _vm._s(_vm.returnContent(_vm.selectPartyInfo, item.label)) + " ")], _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.selectPartyInfo.code && item.label === 'partyI',
        expression: "selectPartyInfo.code && item.label === 'partyI'"
      }],
      staticClass: "iconfont icon-log greenColor",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.hidePopup(item, index, 'copyLink');
        }
      }
    })], 2)]);
  }), _vm.currentModule === 'group' ? _c('div', {
    staticClass: "leftLi"
  }, [_c('div', {
    staticClass: "titleIcon"
  }, [_c('i', {
    staticClass: "iconfont grayColor icon-Frame1"
  }), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.maxPips')))])]), _c('el-input', {
    attrs: {
      "placeholder": "1000",
      "max": 1000
    },
    on: {
      "focus": _vm.selectVal,
      "blur": _vm.savePipLimit
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.savePipLimit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.maxPip,
      callback: function ($$v) {
        _vm.maxPip = $$v;
      },
      expression: "maxPip"
    }
  })], 1) : _vm._e()], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectPartyInfo.code,
      expression: "selectPartyInfo.code"
    }],
    staticClass: "topRight"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "click",
      "popper-class": "partySetting"
    }
  }, [_c('i', {
    staticClass: "el-icon-more pointer",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _c('div', {
    staticClass: "popupBox"
  }, [_c('div', {
    staticClass: "pointer popupDiv",
    on: {
      "click": function ($event) {
        return _vm.showSettingPopup(_vm.selectPartyInfo, '', 'fromInfo');
      }
    }
  }, [_c('i', {
    staticClass: "icon-shezhi3 grayColor iconfont"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.partySetting')))])]), _c('div', {
    staticClass: "copyLink popupDiv"
  }, [_c('i', {
    staticClass: "icon-link grayColor iconfont"
  }), _c('span', {
    staticClass: "joinBtn font_16",
    attrs: {
      "icon": "el-icon-link"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.hidePopup(_vm.selectPartyInfo, _vm.index, 'copyLink');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.copyLink')))])]), _vm.isHost || _vm.State.participantRole === 1 || _vm.State.participantRole === 2 ? _c('div', {
    staticClass: "invitation popupDiv pointer",
    on: {
      "click": function ($event) {
        return _vm.showInvited(_vm.selectPartyInfo, '', 'fromInfo');
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-invitationRules grayColor"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.invitation')))])]) : _vm._e(), _vm.selectPartyInfo.coHost != 2 && _vm.currentModule === 'party' ? _c('div', {
    staticClass: "pointer popupDiv",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.showAddCoHost(_vm.selectPartyInfo, _vm.index);
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-touxiang"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.AddCoHost')))])]) : _vm._e(), _vm.selectPartyInfo.coHost == 2 && _vm.currentModule === 'party' ? _c('div', {
    staticClass: "pointer popupDiv",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.quitCoHost(_vm.selectPartyInfo, _vm.index);
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-touxiang"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.deleteCoHost')))])]) : _vm._e(), _c('div', {
    staticClass: "pointer popupDiv disable",
    on: {
      "click": function ($event) {
        return _vm.showDisablePop(_vm.selectPartyInfo);
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "iconfont icon-lock1"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('partyInfo.partyState')))])]), _c('span', {
    class: _vm.returnDisClass
  }, [_vm._v(_vm._s(_vm.partyStatus.enable ? _vm.$t('partyInfo.enable') : _vm.$t('partyInfo.disable')))])]), _vm.selectPartyInfo.coHost != 2 ? _c('div', {
    staticClass: "pointer popupDiv",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.deleteParty(_vm.selectPartyInfo, '', 'fromInfo');
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-delete grayColor"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('invite.remove')))])]) : _vm._e()])]), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectPartyInfo.partyBasicStatus && _vm.selectPartyInfo.partyBasicStatus.enable,
      expression: "selectPartyInfo.partyBasicStatus && selectPartyInfo.partyBasicStatus.enable"
    }],
    staticClass: "joinNow",
    attrs: {
      "href": _vm.openPreviewPage(_vm.selectPartyInfo),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.joinNow')))])], 1)])]), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('i', {
    staticClass: "iconfont icon-a-Frame1"
  }), _c('span', {
    staticClass: "grayColor history"
  }, [_vm._v(_vm._s(_vm.$t('partyInfo.history')))])]), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.historyListScroll,
      expression: "historyListScroll"
    }],
    staticClass: "list scrollbar grayColor"
  }, _vm._l(_vm.historyList, function (item) {
    return _c('div', {
      key: item.node.id,
      staticClass: "listLi"
    }, [_c('div', {
      staticClass: "year"
    }, [_vm._v(" " + _vm._s(_vm.showHistoryTime('year', '', item)) + " ")]), _c('div', {
      staticClass: "time"
    }, [_c('span', {
      staticClass: "grayColor liSpan"
    }, [_vm._v(_vm._s(_vm.$t('partyInfo.startTime')) + " ~ ")]), _c('span', {
      staticClass: "grayColor liSpan m_r_12"
    }, [_vm._v(_vm._s(_vm.$t('partyInfo.endTime')) + ":")]), _c('span', {
      staticClass: "timeText"
    }, [_vm._v(" " + _vm._s(_vm.showHistoryTime('hours', 'start', item)) + " ~ ")]), _c('span', {
      staticClass: "m_r_35 timeText"
    }, [_vm._v(" " + _vm._s(_vm.showHistoryTime('hours', 'end', item)) + " ")]), _c('span', {
      staticClass: "timeText m_r_5"
    }, [_vm._v("(" + _vm._s(_vm.showHistoryTime('minutes', '', item)) + ")")])])]);
  }), 0)])]), _vm.removeInfoTips.show ? _c('TipsDailog', {
    attrs: {
      "info": _vm.removeInfoTips
    },
    on: {
      "save": function ($event) {
        return _vm.onSureDeleteParty(_vm.deleteInfo.item, _vm.deleteInfo.index);
      }
    }
  }) : _vm._e(), _c('TipsDailog', {
    staticClass: "joinDailog",
    attrs: {
      "info": _vm.joinPartyInfo
    },
    on: {
      "save": _vm.joinParty
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('start.partyId')) + ":")]), _c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: _vm.joinPartyCode,
      callback: function ($$v) {
        _vm.joinPartyCode = $$v;
      },
      expression: "joinPartyCode"
    }
  })], 1), _c('TipsDailog', {
    staticClass: "disableParty",
    attrs: {
      "info": _vm.disablePartyInfo
    },
    on: {
      "save": _vm.setDisableParty
    }
  }, [_c('div', {
    staticClass: "mean",
    staticStyle: {
      "word-break": "normal"
    }
  }, [_vm._v(_vm._s(_vm.showMeanContent))]), _c('div', [_vm._v(_vm._s(_vm.showConfrimText))])]), _c('setting-dialog', {
    attrs: {
      "showSetting": _vm.settingPopupInfo.show,
      "statusInfo": _vm.partyStatus,
      "currentModule": _vm.currentModule
    },
    on: {
      "callback": _vm.closeSettingDialog
    }
  }), _c('Invited', {
    attrs: {
      "inviteInfo": _vm.inviteInfo,
      "partyCode": _vm.selectPartyInfo.code
    }
  }), _c('TipsDailog', {
    staticClass: "cohost",
    attrs: {
      "info": _vm.coHostInfo,
      "width": "640px"
    },
    on: {
      "open": _vm.getCoHostList,
      "close": _vm.closeCohost
    }
  }, [_c('div', {
    staticClass: "inviteBox"
  }, [_c('div', {
    staticClass: "userListBox"
  }, [_c('i', {
    staticClass: "el-icon-user-solid m_r_20"
  }), _c('el-input', {
    ref: "emailInput",
    class: {
      redBorder: _vm.showErrorEmailText
    },
    attrs: {
      "placeholder": _vm.$t('invite.inviteCohoster'),
      "clearable": ""
    },
    on: {
      "input": _vm.checkInputText
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.saveCoHost.apply(null, arguments);
      }
    },
    model: {
      value: _vm.coHostSearchName,
      callback: function ($$v) {
        _vm.coHostSearchName = $$v;
      },
      expression: "coHostSearchName"
    }
  }), _c('el-button', {
    on: {
      "click": _vm.saveCoHost
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])], 1), _vm.showErrorEmailText ? _c('div', {
    staticClass: "redColor emailWarn"
  }, [_vm._v("* " + _vm._s(_vm.$t('invite.emailCorrectly')))]) : _vm._e(), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.cohostScroll,
      expression: "cohostScroll"
    }],
    staticClass: "hadInviteList scrollbar gray"
  }, [_vm._l(_vm.willInviteCohost, function (user, index) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.removeCoHostInvite(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  }), _vm.willInviteCohost.length ? _c('el-divider') : _vm._e(), _vm._l(_vm.hadInviteCohost, function (user, index) {
    return _c('div', {
      key: user.collaborateEmail,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.collaborateEmail ? user.collaborateEmail.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent",
      class: {
        declined: user.status === 2
      }
    }, [_vm._v(_vm._s(user.collaborateEmail))]), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('personalInfo.pending'),
        "placement": "top-start"
      }
    }, [user.status === 0 ? _c('span', {
      staticClass: "right",
      staticStyle: {
        "margin-left": "15px",
        "color": "#909090"
      }
    }, [_vm._v(_vm._s(_vm.$t("personalInfo.inviting")))]) : _vm._e()]), user.status === 2 ? _c('span', {
      staticClass: "right",
      staticStyle: {
        "margin-left": "15px",
        "color": "#909090"
      }
    }, [_vm._v(_vm._s(_vm.$t("personalInfo.declined")))]) : _vm._e(), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.deleteCohostInvite(user.collaborateUserId, index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  })], 2)]), _c('div', {
    staticClass: "enterReceivedCohost",
    on: {
      "click": _vm.showReceivedPop
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('invite.receivedCohost')))])])]), _c('TipsDailog', {
    staticClass: "receivedCohost",
    attrs: {
      "info": _vm.receivedCohost,
      "width": "820px"
    },
    on: {
      "open": _vm.getReceiverCoHostList,
      "close": _vm.closeReceivedCohost
    }
  }, [_c('el-table', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.receiverCohostScroll,
      expression: "receiverCohostScroll"
    }],
    staticClass: "invitedMe",
    staticStyle: {
      "width": "100%",
      "margin-top": "-18px"
    },
    attrs: {
      "data": _vm.invitedMeList,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": "",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "participant firstName",
          class: scope.row.color
        }, [_vm._v(_vm._s(scope.row.userEmail ? scope.row.userEmail.slice(0, 1) : ''))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": _vm.$t('personalInfo.applicant'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "email",
          class: {
            decline: scope.row.status == '2'
          },
          attrs: {
            "title": scope.row.userEmail
          }
        }, [_vm._v(_vm._s(scope.row.userEmail))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "partyName",
      "label": _vm.$t('personalInfo.partyName'),
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "email",
          class: {
            decline: scope.row.status == '2'
          },
          attrs: {
            "title": scope.row.userEmail
          }
        }, [_vm._v(_vm._s(scope.row.partyName ? scope.row.partyName : scope.row.partyCode))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "width": "160",
      "label": _vm.$t('personalInfo.inviteationTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.showInvitedTime(scope.row.createTime)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "label": _vm.$t('personalInfo.Permission')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          class: {
            pedding: scope.row.status == '0'
          }
        }, [_vm._v(_vm._s(_vm.returnText(scope.row)))]), _c('el-select', {
          attrs: {
            "popper-class": "permission"
          },
          on: {
            "change": result => {
              _vm.controlPermission(result, scope.row);
            }
          },
          model: {
            value: scope.row.select,
            callback: function ($$v) {
              _vm.$set(scope.row, "select", $$v);
            },
            expression: "scope.row.select"
          }
        }, _vm._l(_vm.options, function (item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": _vm.$t(`personalInfo.${item.label}`),
              "value": item.value
            }
          });
        }), 1)];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "bottom-start",
            "width": "200",
            "trigger": "hover",
            "popper-class": "remove"
          }
        }, [_c('i', {
          staticClass: "el-icon-more right pointer",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }), _c('span', {
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              return _vm.deleteCollaborateByOtherInvite(scope.row);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])];
      }
    }])
  })], 1)], 1), _c('TipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.receiveCoHostInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlCohostInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlCohostInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  })])]), _c('div', [_c('p', {
    staticStyle: {
      "color": "#4A90E2",
      "text-decoration": "underline"
    }
  }, [_vm._v(_vm._s(_vm.receiveCoHostInfo.info.fromEmail))]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('personalInfo.cohostPopupLike')) + " ")]), _c('p', {
    staticStyle: {
      "color": "#4A90E2",
      "text-decoration": "underline"
    }
  }, [_vm._v("\"" + _vm._s(_vm.receiveCoHostInfo.info.PartyName ? _vm.receiveCoHostInfo.info.PartyName : 'ID:' + _vm.receiveCoHostInfo.info.PartyCode) + "\" ")]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupParty')))])])]), _c('div', {
    staticClass: "popupContent",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#28282E"
    }
  }, [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.cohostPopupDetail2')))])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };